import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import PublicHeader from './PublicHeader';
import SqueekitDiagram from './SqueekitDiagram';
import CustomTypesSection from './CustomTypesSection';
import './Landing.css';

const HERO_QUOTES = [
  { name: 'Riverside Custom Homes', address: '1819 Riverfront Drive', date: 'February 17, 2026', price: '1,680.00' },
  { name: "Bee's Flowershop", address: '18 Tulip Drive', date: 'February 17, 2026', price: '54.00' },
  { name: 'Cathy Johnson', address: '824 Park Ave', date: 'February 17, 2026', price: '555.60' },
];

const Landing = () => {
  useEffect(() => {
    document.title = 'Squeekit - Home';
  }, []);

  return (
    <div className="landing">
      <PublicHeader
        showTagline
        rightContent={
          <>
            <Link to="/signin" className="landing__btn landing__btn--primary landing__btn--header">
              Sign In
            </Link>
            <Link to="/signup" className="landing__btn landing__btn--secondary landing__btn--header">
              Sign Up
            </Link>
          </>
        }
      />
      <div className="landing__scroll">
        <section className="landing__hero landing__hero--nucleus">
          <div className="landing__hero-diagram">
            <SqueekitDiagram />
          </div>
        </section>
        <CustomTypesSection />
        <section className="landing__hero landing__hero--quotes">
          <div className="landing__hero-text">
            <p className="landing__hero-headline">
              Customize quotes easily to tailor bid's to each unique window cleaning customer
            </p>
          </div>
          <div className="landing__hero-preview">
            <div className="landing__preview-tiles">
              {HERO_QUOTES.map((q, i) => (
                <div key={i} className="landing__preview-tile" style={{ animationDelay: `${i * 0.1}s` }}>
                  <div className="landing__preview-tile-left">
                    <div className="landing__preview-tile-name">{q.name}</div>
                    <div className="landing__preview-tile-address">{q.address}</div>
                    <div className="landing__preview-tile-date">{q.date}</div>
                  </div>
                  <div className="landing__preview-tile-right">
                    <div className="landing__preview-tile-price">${q.price}</div>
                    <div className="landing__preview-tile-edit">
                      <Pencil className="landing__preview-tile-edit-icon" aria-hidden />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Landing;
